import AppointmentService from "../../services/appointment/appointmentService";
import { mapState, mapGetters } from "vuex";
import UserService from "../../services/user/UserService";
import LocationService from "../../services/masters/LocationService";
const holidaysApi = require("colombia-holidays");
import dayjs from "dayjs";

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      isPaginated: true,
      inputDebounce: "",
      iduser: null,
      columns: [
        {
          field: "range",
          label: "Hora disponible",
          width: "4",
          numeric: true,
        },
      ],
      iscentered:'',
      isShowModal: false,
      statesData: [],
      citiesData: [],
      idG:"",
      scheduleRangeData: [],
      state: null,
      city: null,
      range: null,
      branch: null,
      shippingDate: {},
      scheduleRange: null,
      observation: null,
      cityIsLoading: false,
      cellPhone: null,
      phone: null,
      minDate: {},
      notAllowedDays: [0],
      monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      holidays: [],
      branches: [],
      address: "",
      a:0,
      medicinas:[],
      idBranches: "",
      idBranch: "",
      enabledDays: [],
      formattedDate: "",
      deliveryPoint: null,
      deliveryPoints: [],
      enabledDaysArray: [],
      appointmentDate: "",
      scheduleRanges: [],
      selectedrange: [],
      date: "",
      departamentoseleccionado: "",
      ciudadseleccionada: "",
      arreglomedicamentos:[],
      horafija:'',
      fechafija:'',
    };
  },

  async created() {
    await this.getStates();
    console.log("datos principales ==>",this.editapointment);
   if(this.editapointment.id != null ||  this.editapointment.id != undefined){


    this.selectedMedicines.length= this.editapointment.appointmentMedicines.length;
    this.medicinas= this.editapointment.appointmentMedicines;
    this.patient.name = this.editapointment.patient.name;
    this.deliveryPoint = this.editapointment.deliveryPoint.id;
    this.deliveryPoints= this.editapointment.deliveryPoint.id;
    this.address =  this.editapointment.deliveryPoint.address; 
    this.patient.identification = this.editapointment.patient.identification;
    this.ciudadseleccionada = this.editapointment.deliveryPoint.city.name;
    this.city = this.editapointment.deliveryPoint.city.id;
    this.departamentoseleccionado  = this.editapointment.deliveryPoint.city.idState.name;
    this.state = this.editapointment.deliveryPoint.city.idState.id;
  
    this.user.identification = this.editapointment.patient.identification;
   
    this.userIsAdmin = false;
    this.date = this.editapointment.date;   
    var mifecha = this.editapointment.date.split("-");
    var fechaPrueba =  new Date(mifecha[0],mifecha[1]-1,mifecha[2]);
    this.appointmentDate = fechaPrueba;
    this.selectedrange.hora = this.editapointment.scheduleRangeAppointment.typehour;
    
    this.horafija =this.editapointment.scheduleRangeAppointment.typehour;

    this.fechafija = this.editapointment.date

    await this.getCities();
    await this.getDeliveryPoints();
    await this.getAddressAndAllowedDates();
    await this.getScheduleRanges();
    if(this.editapointment.scheduleRangeAppointment.id == selectedrange.id){
      this.$buefy.toast.open({
        message: "La hora seleccionada es igual a la agendada ",
        type: "is-warning",
      });
    }
   } 

  },
  computed: {
    ...mapState("delivery", {
      patient: "patient",
      provider: "provider",
      orderDetails: "orderDetails",
      selectedMedicines: "selectedMedicines",
      editapointment:"orderDetails",
      setPatient:"setPatient",
    }),
    ...mapState("auth", ["user"]),
    ...mapGetters("delivery", {
      slidingScaleFee: "slidingScaleFee",
    }),
  },

  watch: {
    state() {
      this.getCities();
    },

    city() {
      this.getDeliveryPoints();
    },
  },

  methods: {
    seleccionciudad(){
        document.getElementById("ciudade").value = "";
    },
    seleccionpunto(){
      document.getElementById("punto").value = "";
  },
    home(){
      this.$router.push({ path: "home" });
    },
    routerOrder() {
      this.$router.push({ path: "list-request-appointment" });
    },
    table() {
      this.$router.push("/list-request-appointment");
    },
    openModal() {
      this.isShowModal = true;
    },
    cerrarModal(){
      this.isShowModal = false;
    },
    
    ver(){
     
        if(this.a == 0){
          this.a = 1
          var table = document.getElementById("tablamedicamento");
          table.style.display ="none"
        }else{
          this.a = 0
          var table = document.getElementById("tablamedicamento");
          table.style.display ="block"
        }
    },
    async closeModal() {
      if(this.editapointment.id == null ||  this.editapointment.id == undefined){
        try {
          for (var i = 0; i < this.selectedMedicines.length; i++) {
           var  datosmedi= 
              {
                orderCode: this.selectedMedicines[i]["orderDetailCode"],
                plu: this.selectedMedicines[i]["plu"],
                description: this.selectedMedicines[i]["description"],
                count: this.selectedMedicines[i]["quantity"],
                scaleFee: 0,
              };
              this.arreglomedicamentos.push(datosmedi)
            
          }
         
          const data = {
            patient: {
              id: this.iduser,
              type: this.patient.identificationType,
              document: this.patient.identification,
              fullname: this.patient.name,
              cellPhoneNumber: this.patient.phone,
              phoneNumber: this.patient.phone,
              address: this.patient.address,
            },
            city: this.city,
            date: this.date,
            scheduleRange: this.selectedrange.id,
            deliveryPoint: this.deliveryPoint,
            observation: "",
            userIsAdmin: false,
            user: 15,
             medicines: this.arreglomedicamentos,
          };
  
          const response = await AppointmentService.saveAppointment(data);
          console.log("este se guardo",response)
          this.idG= response.data.id;
          this.statesData = response.data;
          this.citiesData = response.data;
        } catch (error) {}
        this.$buefy.toast.open({
          message: "Cita agendada con éxito ",
          type: "is-success",
        });
        
        this.$router.push({ path: "home" });
        const datos = {
          ids: [this.idG],
        };
      
        let response1 = await AppointmentService.comfirmarAppointment(datos);
        console.log(response1);
  
      }else{
        
        try {
         
          const data = {
            id:  this.editapointment.id,
            patient: {
              id: this.editapointment.patient.id,
              type: this.patient.identificationType,
              document: this.patient.identification,
              fullname: this.patient.name,
              cellPhoneNumber: this.patient.phone,
              phoneNumber: this.patient.phone,
            },
            city: this.city,
            date: this.date,
            scheduleRange: this.selectedrange.id,
            deliveryPoint: this.deliveryPoint,
            observation: "",
            userIsAdmin: false,
            user: 15,
          };
      
          await AppointmentService.editAppointment(data);
        } catch (error) {}
        this.$router.push({ path: "list-request-appointment" });
       
         
      }
      this.isShowModal = false;
         },
    async getData() {
      try {
        const body = {
          identification: this.patient.identification,
        };

        const response = await UserService.getOne(body);
        this.iduser = response.data.id;
      } catch (error) {
        this.showToast("Error consultando la información de usuario", "is-warning");
      }
    },
    async saveAppointment() {
    
this.openModal();
      
      
    },

    async getStates() {
      try {
        if(this.editapointment.id == null ||  this.editapointment.id == undefined){
        this.enabledDaysArray=[];
        this.appointmentDate=[];
        this.scheduleRanges=[];
        this.selectedrange=[];
        this.deliveryPoints=[];
       
        
        
        
        }
        const response = await LocationService.getStatesWithDeliveryPoint();
        this.statesData = response.data;
      } catch (error) {}
    },
    addItem () {
      this.citiesData.push({
        name: this.city,
        id: Date.now()
      })

      this.name = ''
    },
    async getCities() {
      try {
        if(this.editapointment.id == null ||  this.editapointment.id == undefined){
        this.enabledDaysArray=[];
        this.appointmentDate=[];
        this.scheduleRanges=[];
        this.selectedrange=[];
       
        this.deliveryPoints=[];
        this.citiesData.id="";
        this.deliveryPoints.id="";
        this.city= null;
        this.deliveryPoint = null;
        
        }
        this.cityIsLoading = true;
        const data = {
          ids: [this.state],
        };
        const result = await LocationService.getCitiesWithDeliveryPoint(data);
        this.citiesData = result.data;
        this.cityIsLoading = false;
      } catch (error) {
        this.cityIsLoading = false;
      }
    },
   
  
    async getDeliveryPoints() {
      try {
        if(this.editapointment.id == null ||  this.editapointment.id == undefined){
        this.enabledDaysArray=[];
        this.appointmentDate=[];
        this.scheduleRanges=[];
        this.selectedrange=[];
        this.deliveryPoint = null;
        }
        let response = await AppointmentService.getDeliveryPointByCity(
          this.city,
          this.user.identification
        );
        this.deliveryPoints = response.data;

    
        var valordepartamento = this.statesData.find((x) => x.id == this.state);
        this.departamentoseleccionado = valordepartamento.name;
  
        var valorciudades = this.citiesData.find((x) => x.id == this.city);
        this.ciudadseleccionada = valorciudades.name;
  
        let aux = this.deliveryPoints.find((dp) => dp.id == this.deliveryPoint);
        this.address = aux.address;

        this.$forceUpdate();
        console.log("paso get delivery",response);
      } catch (error) {}
    },
    async getAddressAndAllowedDates() {
      if(this.editapointment.id == null ||  this.editapointment.id == undefined){
        this.appointmentDate=[];
        this.scheduleRanges=[];
        this.selectedrange=[];
        this.address="";
      }
     
      console.log("paso getAddressAndAllowedDates")
      var valordepartamento = this.statesData.find((x) => x.id == this.state);
      this.departamentoseleccionado = valordepartamento.name;
      console.log("paso getAddressAndAllowedDates1", valordepartamento)
      var valorciudades = this.citiesData.find((x) => x.id == this.city);
      this.ciudadseleccionada = valorciudades.name;
      console.log("paso getAddressAndAllowedDates2", valorciudades)

      let aux = this.deliveryPoints.find((dp) => dp.id == this.deliveryPoint);
      this.address = aux.address;
      console.log("paso getAddressAndAllowedDates3", aux )
      console.log("paso getAddressAndAllowedDates4",  this.deliveryPoint )
      try {
        const response = await AppointmentService.getAllowedDates(
          this.deliveryPoint,
          false
        );
        
        this.enabledDays = response.data;
        
        console.log("ensabled days ===>>",this.enabledDays);
        this.enabledDaysArray = await this.enabledDays.map((d) => {
          const input = d.date.split("-");
          return new Date(input[0], input[1] - 1, input[2]);
        });
        console.log("dayarray ====>",this.enabledDaysArray)
        if(this.enabledDays== '' || this.enabledDays == null){
          this.$buefy.toast.open({
            message: 'No hay agenda disponible',
            type: 'is-danger'
        })
        }
      
      } catch (error) {
        this.enabledDaysArray=[];
        this.$buefy.toast.open({
          message: 'No hay agenda disponible',
          type: 'is-danger'
      })
          

      }
    },
    async getScheduleRanges() {
      
     console.log("PASO APPOINTMENT DATE ==>",this.appointmentDate);
      this.date = dayjs(this.appointmentDate).format("YYYY-MM-DD");
      // console.log("fechaaaaaa",this.date)
      const selectedDate = this.enabledDays.find((date) => date.date == this.date);
       console.log("fechaaaaaa2",selectedDate)
   
      try {
 if (selectedDate) {
          let response = await AppointmentService.getScheduleRanges(
            selectedDate.id,
            false
          );
         
          
           if (response.data.length === 0) {
            this.$buefy.toast.open({
              message: "No hay turnos disponibles para la fecha seleccionada",
              type: "is-warning",
            });
          } else {
            this.scheduleRanges = response.data.map((x) => {
              var hora = new Date(x.range);
              var datetext = hora.toTimeString();
              datetext = datetext.split(" ")[0];
              x.range = datetext;

              // console.log("range ",x.range.substr(0, 8))
              var time = x.range.substr(0, 5);
              // Check correct time format and split into components
              time = time
                .toString()
                .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

              if (time.length > 1) {
                // If time format correct

                time = time.slice(1); // Remove full string match value
                time[5] = +time[0] < 12 ? " A.M." : " P.M."; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
              }
              //return time; // return adjusted time or original string
              x.hora = time
                .join()
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
                .replace(",", " ")
                .replace(",", " ");
              // x.hora = await this.tConvert(x.range.substr(11,8))
              return x;
            });

            // console.log("new ==",this.scheduleRanges)
          }
        }

        // var data = this.scheduleRanges

        // this.scheduleRange = "";
      } catch (error) {
        console.log(error);
      }
    },
  },
};
